import { ConnextData, System } from "ngx-core-services";
import { BehaviorSubject } from "rxjs";

export enum Portability {
  PORTABLE = 1,
  NOT_PORTABLE,
  ALREADY_PORTED_WITH_ALL_DEVICES,
  ALREADY_PORTED_WITH_SOME_DEVICES,
  FULLY_PORTED,
}

export interface SystemPromotionStatusMap {
  [systemUid: string]: SystemPromotionStatus;
}

export interface SystemPromotionStatus {
  deviceIds?: string[];
  isPromotable?: boolean;
  isFullyPromotedOnASystemThatIKnow?: boolean;
  isPartiallyPromotedOnASystemThatIKnow?: boolean;
  isPartiallyPromotedOnASystemThatIDontKnow?: boolean;
  portability?: Portability;
}

export interface PortabilityPaginationState {
  candidateSystems$: BehaviorSubject<SystemPromotionStatusMap>;
  connextDevices$: BehaviorSubject<{
    [connextId: string]: { devices?: string[]; userLevel?: number };
  }>;
  devices$: BehaviorSubject<{
    [deviceId: string]: { plantId?: string | null };
  }>;
  loading: BehaviorSubject<boolean>;
  defaultPageSize: number;
  isUpdated: boolean;
}

export interface PortabilityPaginationOptions {
  getConnextDeviceAndUserLevel: (
    connextId: string
  ) => Promise<{ devices?: string[]; userLevel?: number }>;
  getDevicesPlantIds: (deviceIds: string[]) => Promise<{ [deviceId: string]: string | null | undefined }>;
  advancedSource: string;
  defaultPageSize: number;
  loading$?: BehaviorSubject<boolean>;
}

export interface PortabilityLoadOptions {
  pageSize?: number;
  currentPage?: number;
  filterCandidateSystems?: (
    candidateSystems: SystemPromotionStatusMap
  ) => SystemPromotionStatusMap;
  filterBaseSystems?: (baseSystems: System[]) => System[];
  sortFunction?: (a: System, b: System) => number;
  hasMore?: (hasMore: boolean) => void;
}
